import { internalUrl } from "../../utilities/internal-url";

export interface BreadcrumbStructuredData {
  "@context": "https://schema.org";
  "@type": "BreadcrumbList";
  itemListElement: ItemListElementStructuredData[];
}

interface ItemListElementStructuredData {
  "@type": "ListItem";
  position: number;
  name: string;
  item: string;
}

interface BuildBreadcrumbStructuredDataArgs {
  breadcrumbs: {
    title: string;
    href: string;
  }[];
  origin: string;
}

export function buildBreadcrumbStructuredData({
  breadcrumbs,
  origin,
}: BuildBreadcrumbStructuredDataArgs): BreadcrumbStructuredData {
  const itemListElements = breadcrumbs.map((breadcrumb, index) => {
    const item = internalUrl({ path: breadcrumb.href, origin });
    const itemListElement: ItemListElementStructuredData = {
      "@type": "ListItem",
      position: index + 1,
      name: breadcrumb.title,
      item,
    };
    return itemListElement;
  });
  return {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement: itemListElements,
  };
}
